import React from "react";
import { Chip, Tooltip } from "@mui/material";
import { Product } from "../../types";
import { formatCurrencyBDT } from "../../utils/currency";

/** A small "Combo" tag for products with combo prices; hover lists them. */
export const ComboChip: React.FC<{ product: Pick<Product, "price_tiers"> }> = ({ product }) => {
    const tiers = product.price_tiers ?? [];
    if (!tiers.length) return null;
    const list = tiers.map((t) => `${t.min_quantity}+ ${formatCurrencyBDT(Number(t.unit_price), { minimumFractionDigits: 0 })} each`).join(" · ");
    return (
        <Tooltip title={`Combo prices: ${list}`}>
            <Chip
                label="Combo"
                size="small"
                color="secondary"
                variant="outlined"
                sx={{ height: 18, "& .MuiChip-label": { px: 0.6, fontSize: "0.65rem", fontWeight: 600 } }}
            />
        </Tooltip>
    );
};

export default ComboChip;
